/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * Metanav module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class Metanav
	 * @extends Tc.Module
	 */
	Tc.Module.Metanav = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			// language selector
			var mod = this,
				$ctx = mod.$ctx,
				$langSwitch = $ctx.find('.scsh-js-language-switch'),
				$businessAreaSwitch = $ctx.find('.scsh-js-business-area-switch');

			$langSwitch.click(function () {
				$langSwitch.trigger('scsh-flyout-open');
			});

			$businessAreaSwitch.click(function () {
				$businessAreaSwitch.trigger('scsh-flyout-open');
			});
			
			callback();
		}
	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Metanav.js
// module id = 366
// module chunks = 0